export default "__VITE_ASSET__DuqJFeF6__"